// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".products_b5enH{background:var(--cp-white);flex-grow:1;width:65%}@media only screen and (min-width:768px){.products_b5enH{margin-top:0}}.products__desktop_FYG7w{min-width:0;width:100%}.productsWrap_96isx{display:grid;grid-template-columns:auto 1fr;grid-column-gap:2.6rem}.productsWrap_96isx .productListWrap_0c53-{grid-column:span 2}.toggleFilterSkeleton_MYwGH{grid-column:2/span 1;grid-row:1/span 2;left:0;margin-right:20px;position:absolute;top:23px;width:252px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"products": "products_b5enH",
	"products__desktop": "products__desktop_FYG7w",
	"productsWrap": "productsWrap_96isx",
	"productListWrap": "productListWrap_0c53-",
	"toggleFilterSkeleton": "toggleFilterSkeleton_MYwGH"
};
module.exports = ___CSS_LOADER_EXPORT___;
